import {
  Box,
  Card,
  CardMedia,
  Divider,
  TextField,
  Typography
} from "@material-ui/core"
import React, { useEffect, useState } from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import GroupsAndEmails from "./Autocomplete"
import { uniqBy } from "lodash"
import noPostsImg from "assets/no-posts-img.svg"
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled"

const Email = ({
  postBody,
  postImage,
  classes,
  setEmailMessage,
  emailMessage,
  emailsTagsArrayToSend,
  setEmailsTagsArrayToSend,
  tags,
  emailsWithTags,
  emailSubject,
  setEmailSubject,
  postAuthor,
  source,
  uploadType,
  videoImage
}) => {
  const [emailsTagsArray, setEmailsTagsArray] = useState([])
  //useEffect to create only one Array with all tags an emails
  useEffect(() => {
    setEmailsTagsArray(
      [
        ...tags.map(x => {
          return { name: x.name, type: "tag", id: x.id }
        }),
        ...emailsWithTags.map(x => {
          return { name: x.email, type: "email", id: x.id }
        })
      ].sort((a, b) => a.name.localeCompare(b.name))
    )
  }, [])

  return (
    <Box display="flex" flexWrap="wrap">
      <Box className={classes.leftContainer}>
        <GroupsAndEmails
          emailsTagsArrayToSend={emailsTagsArrayToSend}
          setEmailsTagsArrayToSend={setEmailsTagsArrayToSend}
          emailsTagsArray={emailsTagsArray}
        />
        <TextField
          label="Subject"
          variant="outlined"
          multiline
          rows="2"
          // className={classes.messageContainer}
          value={emailSubject}
          onChange={e => setEmailSubject(e.target.value)}
          InputProps={{ classes: { input: classes.textfieldText } }}
        />
        <TextField
          label="Your message"
          multiline
          rows="12"
          variant="outlined"
          className={classes.messageContainer}
          value={emailMessage}
          onChange={e => setEmailMessage(e.target.value)}
          InputProps={{ classes: { input: classes.textfieldText } }}
        />
      </Box>
      <Card className={classes.rightContainer}>
        <Typography className={classes.title}>Content being shared</Typography>
        <Divider className={classes.divider} />
        <Box>
          {uploadType && source && (
            <CardMedia
              // className={uploadType === "image" ? classes.image : classes.video}
              className={classes.cardMedia}
              // component={uploadType === "video" ? "video" : "img"}
              component={"div"}
              controls={uploadType === "video"}
              // src={source}
              // title=""
              // preload="metadata"
              // playsInline="playsinline"
            >
              <img
                className={classes.image}
                /* eslint-disable */

                src={
                  uploadType === "video"
                    ? videoImage
                    : source
                    ? source
                    : noPostsImg
                  /* eslint-enable */
                }
                alt="Post"
                onError={e => (e.target.src = noPostsImg)}
              />
              {uploadType === "video" && (
                <Box className={classes.iconContainer}>
                  <PlayCircleFilledIcon className={classes.playIcon} />
                </Box>
              )}
            </CardMedia>
          )}
        </Box>
        <Box>
          <Typography className={classes.author}>
            Author: {" " + postAuthor}
          </Typography>
        </Box>
        <Box className={classes.textContainer}>{postBody}</Box>
      </Card>
    </Box>
  )
}

export default withStyles(styles)(Email)



// WEBPACK FOOTER //
// ./src/dialogs/PublishContainer/steps/Email/index.js